'use client';

import type {
  ProductGridCardPreviewItem,
  ProductGridCardPreviewStyle,
} from '../types';

const MAX_VISIBLE_PREVIEW_ITEMS = 4;

type UseProductGridCardPreviewParams = {
  previewItems: ProductGridCardPreviewItem[];
  previewStyle: ProductGridCardPreviewStyle;
};

export const useProductGridCardPreview = ({
  previewItems,
  previewStyle,
}: UseProductGridCardPreviewParams) => {
  const visiblePreviewCount = Math.min(
    previewItems.length,
    MAX_VISIBLE_PREVIEW_ITEMS,
  );
  const visiblePreviewItems = previewItems.slice(0, visiblePreviewCount);
  const hiddenPreviewCount = Math.max(
    previewItems.length - visiblePreviewItems.length,
    0,
  );

  return {
    hasPreview: previewItems.length > 0,
    isPreviewCard: previewStyle === 'card',
    hiddenPreviewCount,
    visiblePreviewItems,
  };
};
